<template>
	<div>
		<around :cate="2"></around>
	</div>
</template>

<script>
import around from '@/components/data/around.vue'
export default {
	name: 'FrontendPcBigdataFenxian',
	components:{around},

};
</script>

<style lang="scss" scoped>

</style>